import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography, Button } from '@mui/material'
import Iconify from '@src/components/iconify/iconify'

const ResetPasswordConfirmation: React.FC<{
  email?: string
  setShowResetInformation: (value: boolean) => void
}> = ({ email, setShowResetInformation }) => {
  const { t } = useTranslation()

  return (
    <Box textAlign='center'>
      <Iconify color='success.main' sx={{ width: 36, height: 36 }} icon='ep:success-filled' />
      <Typography component='h1' variant='h5' sx={{ mb: 2, fontWeight: 'bold' }}>
        {t('login.reset_password.title')}
      </Typography>
      <Typography variant='body1' color='text.secondary' sx={{ mb: 3, textAlign: 'left' }}>
        {t('login.reset_password.description_start')}
        <Typography component='span' sx={{ fontWeight: 'bold', mx: 1 }}>
          {email}
        </Typography>
        {t('login.reset_password.description_end')}
      </Typography>
      <Button type='submit' variant='contained' onClick={() => setShowResetInformation(false)}>
        {t('login.reset_password.back_button')}
      </Button>
    </Box>
  )
}

export default ResetPasswordConfirmation
